import React, {useState} from 'react';
import {DefaultButton, PrimaryButton} from '@fluentui/react/lib/Button';
import {Dialog, DialogFooter} from '@fluentui/react/lib/Dialog';
import {Checkbox} from '@fluentui/react/lib/Checkbox';

interface Props {
  title: string;
  dialogMessage: string | React.ReactNode;
  checkboxText: string;
  community: any;
  buttonProps: any;
  isDialogHidden: boolean;
  setDialogHidden(flag: boolean): void;
  onClickAction(event: React.MouseEvent<HTMLElement>): void;
}

const DeleteDialogCommunityComponent = (props: Props) => {
  const { buttonProps, isDialogHidden, setDialogHidden, title, dialogMessage, checkboxText, onClickAction } = props;
  const [isActionButtonDisabled, setIsActionButtonDisabled] = useState<boolean>(true);

  const closeDialog = () => {
    setDialogHidden(true);
    setIsActionButtonDisabled(false);
  };

  const onCheckboxChange = (_ev, isChecked) => {
    setIsActionButtonDisabled(!isChecked);
  };

  const handleButtonAction = (event: React.MouseEvent<HTMLElement>) => {
    setIsActionButtonDisabled(true);
    onClickAction(event);
    setDialogHidden(true);
  }

  return (
    <>
      <Dialog
        key='dialog'
        hidden={isDialogHidden}
        onDismiss={closeDialog}
        dialogContentProps={{
          title: title
        }}
        modalProps={{
          isBlocking: true,
          isDarkOverlay: true,
          className: 'govTeams-dialog'
        }}
        styles={{
          root: {
            backgroundColor: 'transparent',
            height: 40,
            paddingLeft: 0
          }
        }}
      >
        <p>
          {dialogMessage}
        </p>
        <Checkbox
          label={checkboxText}
          onChange={onCheckboxChange}
        />
        <DialogFooter>
          <DefaultButton
            onClick={closeDialog}
            text={buttonProps.cancelText}
          />
          <PrimaryButton
            onClick={handleButtonAction}
            disabled={isActionButtonDisabled}
            text={buttonProps.okText}
          />
        </DialogFooter>
      </Dialog>
    </>
  );
};

export default DeleteDialogCommunityComponent;
